// extracted by mini-css-extract-plugin
export default {"container":"SelectClient_container__JKSO8"};